// extracted by mini-css-extract-plugin
export default {"title":"PropDetailList_title__txDu6","detail":"PropDetailList_detail__ocdB4","detailName":"PropDetailList_detailName__jELk+","detailInfo":"PropDetailList_detailInfo__0RFJR"};